/**
 * Created by matthew.prestifilippo on 11/24/14.
 */
'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');

var generate = function (transition, options) {
    options = options || {};
    return function (ajaxOptions) {
        var args = [].slice.call(arguments);
        var attrs;
        ajaxOptions = args.pop();
        attrs = args.shift();
        ajaxOptions = ajaxOptions || {};
        if (options.allowedOnNew || !this.isNew()) {
            ajaxOptions = $.extend(true, ajaxOptions, {
                queries: {
                    workflowAction: transition
                }
            });
        }
        return this.constructor.__super__.save.call(this, attrs, ajaxOptions);
    };
};

module.exports = {
    transition: generate('transition'),
    updateAndTransition: generate('updateAndTransition'),
    update: generate('update', { allowedOnNew: true }),
    save: function (attrs, options) {
        var workflowAction = 'update';
        var attributes = attrs || this.toJSON();
        var hasChangedAttrs = JSON.stringify(_.omit(this.lastSyncAttributes(), 'status')) !== JSON.stringify(_.omit(attributes, 'status'));
        var hasChangedStatus = this.lastSyncAttributes().status !== attributes.status;
        if (hasChangedAttrs && hasChangedStatus) {
            workflowAction = 'updateAndTransition';
        }
        else if (hasChangedStatus) {
            workflowAction = 'transition';
        }
        if (this.isNew()) {
            return this.constructor.__super__.save.call(this, attributes, options);
        }
        return this[workflowAction](attributes, options);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/transitionMixin.js
// module id = 307
// module chunks = 62